import { render, staticRenderFns } from "./TipoEntregaForm.vue?vue&type=template&id=0cef720f&scoped=true"
import script from "./TipoEntregaForm.vue?vue&type=script&lang=js"
export * from "./TipoEntregaForm.vue?vue&type=script&lang=js"
import style0 from "./TipoEntregaForm.vue?vue&type=style&index=0&id=0cef720f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef720f",
  null
  
)

export default component.exports